import { render, staticRenderFns } from "./VSelect2.vue?vue&type=template&id=5b39b53d&"
import script from "./VSelect2.vue?vue&type=script&lang=js&"
export * from "./VSelect2.vue?vue&type=script&lang=js&"
import style0 from "./VSelect2.vue?vue&type=style&index=0&id=5b39b53d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports